import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Search: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 800,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path d="M360.36 324.64l-89.73-83.07a22 22 0 00-4.21-3.07 117.43 117.43 0 10-34.58 34.71 22.34 22.34 0 004.36 5.56l89.73 83.07a22.22 22.22 0 0031.41-1.21l4.23-4.57a22.24 22.24 0 00-1.21-31.42zm-192.58-67.4a82.41 82.41 0 1182.41-82.41 82.41 82.41 0 01-82.41 82.41z" />
			</svg>
		</animated.span>
	)
}

export { Search }
